import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CardMedia from '@material-ui/core/CardMedia';
import Zoom from '@material-ui/core/Zoom';

const styles = theme => ({
    root: {
      width: '30%',
      minWidth: '380px',
      height: '500px',
      alignItems: 'center',
      justifyContent: 'center',
    },
    bg_image: {
      width: '80%',
      height: '80%',
      backgroundImage: "url(" + "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1583440742122_banner.png" + ")",
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      margin: '10%'
    },
    media : {
      marginTop: 30,
      [theme.breakpoints.down('sm')]: {
        height: 240,
        width: 210,
        marginTop: 80,
      },
      [theme.breakpoints.up('md')]: {
        height: 290,
        width: 250
      },
      [theme.breakpoints.up('lg')]: {
        height: 300,
        width: 260
      },
    },
    overlay: {
      marginTop: '-35vh',
      color: 'black',
    },
    nobutton: {
      width: '200px',
      minHeight: '5vh',
      backgroundColor: 'white',
      borderColor: '#F6277F',
      borderWidth: 2,
      border: 'solid 1px',
      "&:hover": {
        backgroundColor: "#F6277F",
        color: 'white'
      }
    },
    yesbutton: {
      width: '200px',
      minHeight: '5vh',
      backgroundColor: '#F6277F',
      color: 'white',
      "&:hover": {
        backgroundColor: "white",
        color: '#F6277F'
      }
    },
    center: {
      textAlign: 'center'
    }
});

class EntryPage extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      entry: false
    };
  }

  componentDidMount(){
    document.title = "CanaWho"
  }

  handleno(){
    this.setState({
      entry: true
    })
  }

  handleyes = () => {
    this.props.parentCallback(false);
  }

  render() {
    const { classes } = this.props;

    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ minHeight: '100vh' }}
      >
        <Paper className={classes.root}>
          <Grid className={classes.bg_image} align="center" justify="center" elevation={0}>
            {!this.state.entry ?
            <Grid container style={{ width: '100%', height: '100%'}} alignItems="center" justify="center">
              <Typography style={{ color: 'black', fontWeight: 'bold', fontFamily: 'Open Sans', fontSize: '30px', textAlign: 'center'}}>
                  Are you over the age of 19?
              </Typography>
              <Typography style={{ color: 'black', fontFamily: 'Open Sans', fontSize: '20px', textAlign: 'center' }}>
                You must be over the age of 19 in order to access this website, thank you.
              </Typography>
              <Grid container alignItems="center" justify="center" style={{marginTop: '15px'}}>
                <Grid item xs={12} md={12} lg={6} xl={6} align="center">
                  <Button variant="contained" className={classes.nobutton} onClick={() => this.handleno()}>No I'm not</Button>
                </Grid>                
                <Grid item xs={12} md={12} lg={6} xl={6} align="center">
                  <Button variant="contained" className={classes.yesbutton} onClick={() => this.handleyes()}>Yes I am</Button>
                </Grid>                
              </Grid>
            </Grid> :
            <Zoom in={true}>
              <Grid container style={{ width: '100%', height: '100%'}} alignItems="center" justify="center">
                <CardContent className={classes.center}>
                  <Typography style={{ flexGrow: 1, color: 'black', fontWeight: 'bold', fontFamily: 'Open Sans', fontSize: '2vw' }}>
                    Uh Oh, You are not old enough.
                  </Typography>
                  <Typography style={{ flexGrow: 1, color: 'black', fontFamily: 'Open Sans', fontSize: '0.75vw' }}>
                    You must over the age of 19 in order to access this website, thank you.<br/><br/>Have a wonderful day!
                  </Typography>
                </CardContent>
              </Grid>
            </Zoom>
            }
          </Grid>
        </Paper>
      </Grid>
    );
  }
}

EntryPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EntryPage);